var map = {
	"./become/en-GB.json": 84503,
	"./become/en.json": 43218,
	"./become/es.json": 5478,
	"./become/fr-CA.json": 70145,
	"./become/pt.json": 39662,
	"./clinical-forms/en-GB.json": 79555,
	"./clinical-forms/en.json": 96375,
	"./clinical-forms/es.json": 94284,
	"./clinical-forms/fr-CA.json": 17331,
	"./clinical-forms/pt.json": 31333,
	"./onboarding/en-GB.json": 62995,
	"./onboarding/en.json": 48383,
	"./onboarding/es.json": 34218,
	"./onboarding/fr-CA.json": 729,
	"./onboarding/pt.json": 87888
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 70263;